import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=c8b09afc&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style0 from "./Index.vue?vue&type=style&index=0&id=c8b09afc&lang=less&scoped=true&"
import style1 from "./Index.vue?vue&type=style&index=1&id=c8b09afc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8b09afc",
  null
  
)

export default component.exports